import { ReactNode } from "react";

interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
}

export const EmptyState = ({
  icon,
  title,
  description,
  action,
}: EmptyStateProps) => (
  <div className="flex flex-col items-center justify-center gap-3 rounded-lg border border-dashed p-12 text-center">
    {icon && <div className="text-muted-foreground">{icon}</div>}
    <div className="text-lg font-medium">{title}</div>
    {description && (
      <p className="max-w-sm text-sm text-muted-foreground">{description}</p>
    )}
    {action && <div className="pt-1">{action}</div>}
  </div>
);
